var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moduleReady)?_c('product-configurator',{attrs:{"module-id":_vm.moduleId,"is-modal":_vm.isModal,"edit-mode":_vm.editMode}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }